import { ProductsInput, ProductsOutput } from "../interfaces/products";
import { BaseService } from "./BaseService";

export class ProductsService extends BaseService<
  ProductsInput,
  ProductsOutput
> {
  constructor() {
    super();
    this.path = "products";
  }

  async metricCount(): Promise<number> {
    const url = `${this.path}/metrics/count`;
    const response = await this.request<number>(url, {
      method: "GET",
    });

    return response;
  }
}
